export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6375.60e8e7fb.jpg";